import { AxiosPromise } from 'axios';
import Api, { baseURL } from '../../configs/AxiosConfig';
import {
  AuditTrailColumns,
  AuditTrailEventTypesResponse,
  AuditTrailFilter,
  AuditTrailResponse,
} from '../../models/AuditTrailModels';
import { FileFormat } from '../../models/ImportModels';
import { downloadFile } from '../../utils/files/downloadFile';

const AuditTrailService = {
  api: {
    fetchAuditTrailEventTypes: (): AxiosPromise<AuditTrailEventTypesResponse> => Api.get(`/audit/event-types`),
    fetchAuditTrail: (filter: AuditTrailFilter): AxiosPromise<AuditTrailResponse> => Api.post(`/audit/list`, filter),
    fetchTableColumns: (): AxiosPromise<AuditTrailColumns> => Api.get(`/audit/columns`, {}),
    exportData: (filter: AuditTrailFilter, format: FileFormat, fileName: string): Promise<void> => {
      // Build query string from params and format
      const queryParams = new URLSearchParams();

      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined) {
          queryParams.append(key, String(value));
        }
      });
      queryParams.append('format', format.toUpperCase());

      return downloadFile({
        url: `${baseURL}/audit/export?${queryParams.toString()}`,
        filename: fileName,
      });
    },
  },
};

export default AuditTrailService;
